import React from "react";
import {
  AlternateApproverSelect,
  Box,
  BoxSection,
} from "../../../../../../components";
import { Col, Row, Form, Input, DatePicker, Select } from "antd";

export const CreateECEnglishForm = () => {
  return (
    <Box title="Content">
      <Row gutter={[32, 0]}>
        <Col span={12}>
          <Form.Item required label="Full name" name="fullName">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Date of Birth" name="dateOfBirth">
            <DatePicker className="min-w-full" placeholder="Select date..." />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item required label="Passport No" name="passportNo">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item required label="Issued Date" name="issuedDate">
            <DatePicker className="min-w-full" placeholder="Select date..." />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item required label="Issued Place" name="issuedPlace">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item required label="Title" name="title">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item required label="Work location" name="workLocation">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <BoxSection title="Contract term">
        <Row gutter={[32, 0]}>
          <Col span={12}>
            <Form.Item required label="From" name="from">
              <DatePicker
                className="min-w-full"
                placeholder="Select date from..."
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item required label="To" name="to">
              <DatePicker
                className="min-w-full"
                placeholder="Select date to..."
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item required label="Approver" name="approverBy">
              <Select options={[]} placeholder="Select approver..." />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Alternate Approver" name="alternateApproverBy">
              <AlternateApproverSelect placeholder="Select alternate approver..." />
            </Form.Item>
          </Col>
        </Row>
      </BoxSection>
    </Box>
  );
};
